export default __webpack_public_path__ + "static/armony-plus-scheda-tecnica-6249c0c4716d3c618d6ac6f9faed7072.pdf";